module.exports = __webpack_public_path__ + "static/media/spinner.bea9a326.gif";